import type {CSS} from '@pinecast/styles';
import styled from '@pinecast/styles';
import * as React from 'react';

import {DEFAULT_FONT} from './constants';

const WrapperLabel = styled(
  'label',
  {
    display: 'flex',
    padding: '0 0 20px',

    ':not(:empty) ~ .Radio--WrapperLabel': {
      marginTop: -8,
    },
  },
  {className: 'Radio--WrapperLabel Label--NativeLabel'},
);
const InvisibleRadio = styled(
  'input',
  (_, designColors) => ({
    border: 0,
    display: 'block',
    flex: '0 0',
    height: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    opacity: 0,
    padding: 0,
    width: 0,

    ':focus': {
      outline: 'none',
    },
    ':focus ~ .Radio-text::before': {
      boxShadow: `inset 0 0 0 1px ${designColors.borderGrayAccent}, inset 0 0 0 0 ${designColors.accentBlue}, 0 0 0 2px ${designColors.accentBlueLight}`,
    },
    ':checked ~ .Radio-text::before': {
      boxShadow: `inset 0 0 0 0 ${designColors.borderGrayAccent}, inset 0 0 0 5px ${designColors.accentBlue}, 0 0 0 0 ${designColors.accentBlueLight}`,
    },
    ':checked:focus ~ .Radio-text::before': {
      boxShadow: `inset 0 0 0 0 ${designColors.borderGrayAccent}, inset 0 0 0 5px ${designColors.accentBlue}, 0 0 0 2px ${designColors.accentBlueLight}`,
    },
  }),
  {className: 'Radio--InvisibleRadio', type: 'radio'},
);

const Text = styled(
  'div',
  (
    {
      $alignInput,
      $disabled,
    }: {
      $alignInput: 'top' | 'center';
      $disabled: boolean;
    },
    designColors,
  ) => ({
    alignItems: 'center',
    display: 'block',
    fontFamily: DEFAULT_FONT,
    fontSize: 14,
    fontWeight: 500,
    flex: '1 1',
    opacity: $disabled ? 0.5 : 1,
    paddingLeft: 24,
    position: 'relative',
    transition: 'opacity 0.2s',

    '::before': {
      backgroundColor: '#fff',
      borderRadius: '100%',
      bottom: 0,
      boxShadow: `inset 0 0 0 1px ${designColors.borderGrayAccent}, inset 0 0 0 0 ${designColors.accentBlue}, 0 0 0 0 ${designColors.accentBlueLight}`,
      content: '""',
      height: 16,
      left: 0,
      margin: $alignInput === 'top' ? '0 auto auto' : 'auto',
      position: 'absolute',
      top: $alignInput === 'top' ? 1 : 0,
      transition: 'box-shadow 0.2s',
      width: 16,
      zIndex: 1,
    },
  }),
  {className: 'Radio-text'},
);

const Radio = ({
  alignInput = 'center',
  checked,
  disabled,
  hideFromScreenReaders,
  name,
  onChange,
  style,
  tabIndex,
  text,
}: {
  alignInput?: 'top' | 'center';
  checked: boolean;
  disabled?: boolean;
  hideFromScreenReaders?: boolean;
  name?: string;
  onChange: (checkedValue: boolean) => void;
  style?: CSS;
  tabIndex?: number;
  text: React.ReactNode;
}) => {
  return (
    <WrapperLabel style={style}>
      <InvisibleRadio
        aria-hidden={hideFromScreenReaders}
        checked={checked}
        disabled={disabled}
        name={name}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.checked)
        }
        tabIndex={tabIndex}
      />
      <Text $alignInput={alignInput} $disabled={disabled || false}>
        {text}
      </Text>
    </WrapperLabel>
  );
};

export default Radio;
